import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import AppModel from '../DataModel/AppModel';
import {ListItem} from 'material-ui/List';
import CircularProgress from 'material-ui/CircularProgress';
import Machine from 'material-ui/svg-icons/action/settings-remote';
import Avatar from 'material-ui/Avatar';
import {blue500} from 'material-ui/styles/colors';
import moment from 'moment-timezone';

export default
@observer class MachineSERPElement extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  infoLine(m) {
    let customerIdMap = AppModel.customerIdMap;
    let customer = customerIdMap.get(m.id_customer);
    return uiMsg('CUSTOMER')+": "+customer.name;
  }

  render() {
    var machine = this.props.machine;
    let selectionHandler = this.props.onSelect;
    return (
      <ListItem
          value={machine}
          leftAvatar={<Avatar icon={<Machine />}
          backgroundColor={blue500} />}
          primaryText={machine.name + " ("+machine.id+")"}
          secondaryText={this.infoLine(machine)}
          onTouchTap={ ()=>{selectionHandler(machine)} }
      />
    )
  }

}



/** WEBPACK FOOTER **
 ** ./src/components/MachineSERPElement.jsx
 **/